export default __webpack_public_path__ + "static/media/time.5ac49952.svg";